import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { cn } from '../lib/utils';
import { bonuses, type BonusAccent } from '../data/system';
const accentStyles: Record<BonusAccent, {
  badge: string;
  dot: string;
}> = {
  electric: {
    badge: 'bg-electric/10 text-electric-deep',
    dot: 'bg-electric'
  },
  perf: {
    badge: 'bg-perf/15 text-perf-deep',
    dot: 'bg-perf'
  },
  ember: {
    badge: 'bg-ember/20 text-ember-deep',
    dot: 'bg-ember'
  },
  aqua: {
    badge: 'bg-aqua/15 text-aqua-deep',
    dot: 'bg-aqua'
  }
};
const flow = ['Planificar', 'Organizar la nutrición', 'Prepararte', 'Registrar tu progreso'];
export function Bonuses() {
  return <section aria-label="Bonos" className="bg-white" data-id="element-18" data-mp="3o3y2fj9yym3d">
      <div className="mx-auto max-w-6xl px-5 py-16 lg:py-24" style={{
      paddingTop: "17px",
      paddingBottom: "21px"
    }} data-id="element-19" data-mp="3t1hk6t5vlh02">
        <div className="text-center" data-id="element-20" data-mp="1mb1kdchn6j9r">
          <p className="inline-flex items-center gap-1.5 rounded-full bg-ember/20 px-3 py-1 text-xs font-bold uppercase tracking-wider text-ember-deep" data-id="element-21" data-mp="1r9347zmw6mma">
            Oferta especial de lanzamiento
          </p>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase leading-none text-navy sm:text-6xl" data-id="element-22" data-mp="3dfv6x3bghlbv">
            Hoy puedes recibir los 4 bonos complementarios
          </h2>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-23" data-mp="3n4mwj4t1ntjm">
          {bonuses.map((b, i) => {
          const a = accentStyles[b.accent];
          return <motion.article key={b.n} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.3,
            delay: i % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex h-full flex-col rounded-2xl border border-navy/10 bg-warm p-5 sm:p-6" data-id="element-24" data-mp="2zg3wtdo28p35" data-mpi={i}>
                <div className="flex gap-4 sm:gap-5" data-id="element-25" data-mp="no6rfo6edgpx">
                  <img src={b.cover} alt={`Portada de ${b.title}`} width={1122} height={1402} loading="lazy" decoding="async" className="h-auto w-24 shrink-0 self-start drop-shadow-[0_12px_16px_rgba(16,28,44,0.25)] sm:w-32" data-id="element-26" data-mp="irq1qpjjuuaq" />
                  <div className="min-w-0 flex-1" data-id="element-27" data-mp="3hgg4nndw1sa1">
                    <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-28" data-mp="3ljuluhdkcep2">
                      <span className={cn('inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-bold', a.badge)} data-id="element-29" data-mp="3qipd87pljbks">
                        <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-30" data-mp="2ttq30n5gbzpy" /> Bono {b.n}
                      </span>
                      <span className="whitespace-nowrap text-sm font-bold" data-id="element-31" data-mp="2xu9zrpm451bk">
                        <span className="text-navy/40 line-through" data-id="element-32" data-mp="32sbk0dv9z6om">{b.price}</span>{' '}
                        <span className="text-perf-deep" data-id="element-33" data-mp="37kv844rl9k7o">GRATIS</span>
                      </span>
                    </div>
                    <h3 className="mt-3 font-display text-xl font-extrabold uppercase leading-tight text-navy sm:text-2xl" data-id="element-34" data-mp="2a3wh2ppf4etn">
                      {b.title}
                    </h3>
                    <p className="mt-1.5 text-sm font-semibold leading-snug text-navy/65" data-id="element-35" data-mp="27iyfl1nncgk6">{b.subtitle}</p>
                  </div>
                </div>
                <div className="mt-4 space-y-2 text-sm leading-relaxed text-navy/70" data-id="element-36" data-mp="1xltu741mkp4f">
                  {b.desc.map(d => <p key={d} data-id="element-37" data-mp="1tk8ktsoausyz">{d}</p>)}
                </div>
                <ul className="mt-auto flex flex-wrap gap-1.5 pt-5" data-id="element-38" data-mp="1tjp1q8mwxyjd">
                  {b.tags.map(t => <li key={t} className="inline-flex items-center gap-1.5 rounded-md border border-navy/10 bg-white px-2 py-1 text-xs font-medium text-navy/75" data-id="element-39" data-mp="1olxdbolh8ujx">
                      <span className={cn('h-1.5 w-1.5 rounded-full', a.dot)} aria-hidden="true" data-id="element-40" data-mp="1ev2m05tdj4rm" />
                      {t}
                    </li>)}
                </ul>
              </motion.article>;
        })}
        </div>

        <div className="mt-10 rounded-2xl bg-navy px-6 py-8 text-center text-white sm:px-10" data-id="element-41" data-mp="15uxi45ne2oi7">
          <p className="font-display text-2xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-42" data-mp="10vb2jpk38w68">
            4 herramientas complementarias — <span className="text-perf" data-id="element-43" data-mp="30ycauvs09aj5">gratis solo por hoy</span>
          </p>
          <p className="mt-2 text-sm text-white/65" data-id="element-44" data-mp="34ycowfb6zjpo">
            Valor total <span className="line-through" data-id="element-45" data-mp="2r896y0jcic61">120 USD</span> · Con Sistema Triatlón Completo™
          </p>
          <p className="mt-6 text-sm text-white/70" data-id="element-46" data-mp="2w6u6ryuoqtty">
            No recibes únicamente el sistema principal. También obtienes herramientas diseñadas para ayudarte a:
          </p>
          <p className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 font-display text-xl font-bold uppercase tracking-wide sm:text-2xl" data-id="element-47" data-mp="2hc64etkl0bik">
            {flow.map((f, i) => <React.Fragment key={f} data-id="element-48" data-mp="28azr0td8bgtj" data-mpi={i}>
                {i > 0 && <span className="text-electric" aria-hidden="true" data-id="element-49" data-mp="2d7q5jc9dy4cu">→</span>}
                <span className="whitespace-nowrap" data-id="element-50" data-mp="6hs879yeqh2w">{f}</span>
              </React.Fragment>)}
          </p>
          <p className="mt-4 text-sm text-white/60" data-id="element-51" data-mp="bgldwg7gd3si">
            Todo dentro de una propuesta digital que reúne los principales componentes de tu preparación para triatlón.
          </p>
        </div>
      </div>
    </section>;
}